import { AssetIcon, AssetNetworkWrapper, NetworkIcon } from './styles';

type AssetWithNetworkIconType = {
  assetIconUrl?: string;
  networkIconUrl?: string;
  assetIconSize?: string | number;
  networkIconSize?: string | number;
};
const AssetWithNetworkIcon: React.FC<AssetWithNetworkIconType> = ({
  assetIconUrl,
  networkIconUrl,
  assetIconSize = 3.2,
  networkIconSize = 1.2,
}) => {
  if (!assetIconSize && !networkIconUrl) return null;

  return (
    <AssetNetworkWrapper>
      <AssetIcon size={assetIconSize} src={assetIconUrl} />
      {networkIconUrl && (
        <NetworkIcon size={networkIconSize} src={networkIconUrl} />
      )}
    </AssetNetworkWrapper>
  );
};

export default AssetWithNetworkIcon;
